const normalizePersonaText = (value) => String(value ?? "").trim()

const normalizePersonaSortableText = (value) => normalizePersonaText(value).toLocaleLowerCase("es")

const escapeRegex = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")

const stripTextFromDescripcion = (descripcion, text) => {
  const descripcionNormalizada = normalizePersonaText(descripcion)
  const textNormalizado = normalizePersonaText(text)

  if (!descripcionNormalizada || !textNormalizado) return descripcionNormalizada

  const textRegex = new RegExp(`(^${escapeRegex(textNormalizado)}\\s+|\\s+${escapeRegex(textNormalizado)}$)`, "i")
  const descripcionSinText = descripcionNormalizada.replace(textRegex, "").trim()

  return descripcionSinText || descripcionNormalizada
}

const splitDescripcion = (descripcion) => {
  const descripcionNormalizada = normalizePersonaText(descripcion)
  if (!descripcionNormalizada) return { nombre: "", apellido: "" }

  if (descripcionNormalizada.includes(",")) {
    const [apellido, ...nombreParts] = descripcionNormalizada.split(",")
    return {
      apellido: normalizePersonaText(apellido),
      nombre: normalizePersonaText(nombreParts.join(",")),
    }
  }

  const parts = descripcionNormalizada.split(/\s+/).filter(Boolean)
  if (parts.length <= 1) {
    return { nombre: descripcionNormalizada, apellido: "" }
  }

  return {
    nombre: parts.slice(0, -1).join(" "),
    apellido: parts.slice(-1).join(" "),
  }
}

export const resolvePersonaParts = (persona = {}) => {
  const descripcion = normalizePersonaText(persona?.descripcion)
  const nombreRaw = normalizePersonaText(persona?.nombre)
  const apellidoRaw = normalizePersonaText(persona?.apellido)

  if (nombreRaw && apellidoRaw) {
    return { nombre: nombreRaw, apellido: apellidoRaw }
  }

  if (apellidoRaw) {
    return {
      apellido: apellidoRaw,
      nombre: nombreRaw || stripTextFromDescripcion(descripcion, apellidoRaw),
    }
  }

  if (nombreRaw) {
    return {
      nombre: nombreRaw,
      apellido: stripTextFromDescripcion(descripcion, nombreRaw),
    }
  }

  return splitDescripcion(descripcion)
}

export const formatPersonaApellidoNombre = (persona = {}) => {
  const { nombre, apellido } = resolvePersonaParts(persona)

  if (apellido && nombre) return `${apellido}, ${nombre}`
  if (apellido) return apellido
  if (nombre) return nombre
  return "Sin nombre"
}

export const comparePersonasByApellidoNombre = (personaA = {}, personaB = {}) => {
  const personaAResuelta = resolvePersonaParts(personaA)
  const personaBResuelta = resolvePersonaParts(personaB)

  const apellidoA = normalizePersonaSortableText(personaAResuelta.apellido)
  const apellidoB = normalizePersonaSortableText(personaBResuelta.apellido)

  if (apellidoA && !apellidoB) return -1
  if (!apellidoA && apellidoB) return 1

  const compareApellido = apellidoA.localeCompare(apellidoB, "es")
  if (compareApellido !== 0) return compareApellido

  const nombreA = normalizePersonaSortableText(personaAResuelta.nombre)
  const nombreB = normalizePersonaSortableText(personaBResuelta.nombre)

  return nombreA.localeCompare(nombreB, "es")
}

export const sortPersonasByApellidoNombre = (personas = []) =>
  [...personas].sort((personaA, personaB) => comparePersonasByApellidoNombre(personaA, personaB))
